import styled from "styled-components";
import { Link as LinkS } from "react-router-dom";

export const NavMenu = styled.ul`
	display: flex;
	align-items: center;
	list-style: none;
	text-align: center;
	margin-right: -22px;

	@media screen and (max-width: 720px) {
		display: none;
	}
`;

export const NavItem = styled.li`
	height: 80px;
`;

export const Navlinks = styled(LinkS)`
	display: flex;
	align-items: center;
	text-decoration: none;
	padding: 0 1rem;
	height: 100%;
	cursor: pointer;
`;

export const H3links = styled.h3`
	/* color: ${({ changeColor }) =>
		changeColor.changeColor ? "var(--darkGrey)" : "var(--white)"}; */
	color: var(--darkGrey);
	text-decoration: none;
	cursor: pointer;
	display: inline-block;
	position: relative;

	:before {
		position: absolute;
		content: "";
		width: 100%;
		height: 2px;
		bottom: -2px;
		left: 0;
		background-color: ${({ changeColor }) =>
			changeColor.changeColor ? "var(--darkGrey)" : "var(--white)"};
		visibility: hidden;
		transform: scaleX(0);
		transition: all 0.3s ease-in-out 0s;
	}

	:hover:before {
		visibility: visible;
		transform: scaleX(1);
	}
`;
